import { render } from "./battery-monitor.vue?vue&type=template&id=44f24d9f&scoped=true"
import script from "./battery-monitor.vue?vue&type=script&lang=js"
export * from "./battery-monitor.vue?vue&type=script&lang=js"

import "./battery-monitor.vue?vue&type=style&index=0&id=44f24d9f&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f24d9f"]])

export default __exports__